import React, { PureComponent } from 'react';
import moment from 'moment';
import DatePicker from "react-datepicker";

import ShowIff from './ui/ShowIff.js';
import Desktop from './ui/Desktop.js';
import Mobile from './ui/Mobile.js';

import api from '../api/index.js';

import './DateRange.scss';

class DateRange extends PureComponent {
	constructor(props) {
		super(props);
		this.state = {
			StartDate: this.props.StartDate || moment().startOf('year').toDate(),
			EndDate: this.props.EndDate || moment().endOf('year').toDate(),
			selection: this.props.Selection || 'current_year'
		};
	}
	
	
	onStartDateChange = (date) => { 
		this.setState({StartDate: date}, this.changed);
	}
	
	
	onEndDateChange = (date) => { 
		this.setState({EndDate: date}, this.changed);
	}
	
	
	onSelectChange = (e) => { 
		let start = this.state.StartDate;
		let end = this.state.EndDate;
		
		switch(e.target.value) {
			case 'current_year':
				start = moment().startOf('year').toDate();
				end = moment().endOf('year').toDate();
				break;
			case 'last_year':
				start = moment().subtract(1, 'year').startOf('year').toDate();
				end = moment().subtract(1, 'year').endOf('year').toDate();
				break;
			default:
				break;
		}
		
		this.setState({
			StartDate: start,
			EndDate: end,
			selection: e.target.value
		}, this.changed);
	}
	
	changed = () => {
		if (this.state.selection !== 'custom') {
			this.send_callback();
		}
	}
	
	applyClick = (e) => {
		e.preventDefault();
		this.send_callback();
	}
	
	
	send_callback() {
		// If StartDate > EndDate, alert the user.
		if (this.state.StartDate > this.state.EndDate) 
			api.error({message: "Your end date precedes your start date, are you sure that's what you want?"});
			// Maybe have an apply button???
		if (this.props.onRangeChange) {
			this.props.onRangeChange(this.state.selection, this.state.StartDate, this.state.EndDate);
		}
	}

	render() {
		return (
			<div className="DateRange">
				<label>{this.props.label}</label>
				<select name="ViewRange" onChange={this.onSelectChange} value={this.state.selection}>
					<option value="current_year">This year</option>
					<option value="last_year">Last year</option>
					<option value="custom">Custom</option>
				</select>
				<ShowIff iff={this.state.selection === 'custom'}>
					<div className="StartDate">
						<Mobile>From: </Mobile>
						<DatePicker
								className="StartDate"
								selected={this.state.StartDate}
								onChange={this.onStartDateChange}
						/>
					</div>
					<Desktop>to</Desktop>
					<div className="EndDate">
						<Mobile>To: </Mobile>
						<DatePicker 
								id="EndDate"
								selected={this.state.EndDate}
								onChange={this.onEndDateChange}
								
								popperPlacement="top-end"
								popperModifiers={{
								  offset: {
								  },
								  preventOverflow: {
									enabled: true,
									escapeWithReference: true, // force popper to stay in viewport (even when input is scrolled out of view)
									boundariesElement: 'viewport'
								  }
								}}
						/>
					</div>
					<button className="block" onClick={this.applyClick}>Apply</button>
				</ShowIff>
			</div>
		);
	}
}

export default DateRange;
